module.exports = __webpack_public_path__ + "static/img/card3.734b3f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card3.png
// module id = eFCX
// module chunks = 0